import React from 'react';
import { BrowserRouter as Router, Route, Routes, } from 'react-router-dom';
import Navbar from './components/Navbar'; 
import HomePage from './pages/HomePage';
import FeedBack from './pages/FeedBack';
import FeedbackList from './pages/FeedbackList';
import Register from './pages/Register';
import Login from './pages/Login';
import Footer from './components/Footer';
import TermsAndConditions from './pages/termAndConditions';
import Profile from './pages/Profile';
import ChangePassword from './pages/ChangePassword'; 
import CompleteAccount from './pages/CompleteAccount';
import Dashboard from './pages/Dashboard';
import LiveOrders from './pages/LiveOrders';
import TodaysSales from './pages/TodaySales';
import EditMenu from './pages/EditMenu';
import OrderPage from './pages/OrderPage';
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import { CartProvider } from "./context/CartContext";
import ViewCart from './components/ViewCart'; 
import QRCodeGenerator from './pages/QRCodeGenerator';
import AdminPage from './pages/AdminPage';


function App() {
  return (
    <CartProvider>  
    <Router>
      <div className="App bg-white"> 
        <Navbar />
        <Routes>
        <Route path="/" element={<HomePage />} /> 
        <Route path="/view-cart" element={<ViewCart />} />
          <Route  path="/feedback" element={<FeedBack />} />
          <Route  path="/feedbacklist" element={<FeedbackList />} />
          <Route  path="/register" element={<Register />} />
          <Route  path="/login" element={<Login />} /> 
          <Route  path="/profile" element={<Profile />} />
          <Route  path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route  path="/change-password" element={<ChangePassword />} /> 
          <Route  path="/completeAccount" element={<CompleteAccount />} />
          <Route  path="/dashboard" element={<Dashboard />} />
          <Route  path="/live-orders" element={<LiveOrders  />} />
          <Route  path="/todays-sales" element={<TodaysSales />} />
          <Route  path="/edit-menu" element={<EditMenu />} />
          <Route path="/order/:restaurantId/:tableNumber" element={<OrderPage />} />  
          <Route  path="/QrCode" element={<QRCodeGenerator />} />
          <Route  path="/admin" element={<AdminPage />} />


        </Routes>  
       
        <Footer />
      </div>
    </Router>
    </CartProvider>  
  );
}

export default App;
